const ThemeProvider = {
    /* -- brand colours --*/
    black: "#1b1e1c",
    white: "#ffffff",
    red: "#D22630",
    gray: "#A7A8A9",
    gold: "#856404",
    lime: "#7ED321",
    yellow: "#F8FDF4",
    darkYellow: "#FFC845",
    lightGray: "#f3f3f3",
    lightGray1: "#E6E6E6",
    lightGray2: "#757575",
    lightGray3: "#FEFEFE",
    lightGray4: "#686868",
    lightGray5: "#d9d9d6",
    borderGrey: "#D8D8D8",
    darkGrey: "#3C3D3F",
    darkerGrey: "#A5A6A8",
    lightGreen: "#008755",
    coreGreen: "#94eb5a",
    green: "#00A76A",
    lightGreen2: "#00A76A26",
    heritageGreen: "#008755",
    darkGreen: "#3d4543",
    darkerGreen: "#006150",
    lighterGreen: "#BFE9DA",
    mintGreen: "#9ED8B1",
    lightBlue: "#e6edf5",
    iceBlue: "#72E8F0",
    limeGreen: "#94EB54",
    darkLimeGreen: "#73C73C",
    darkBlue: "#3c3d3f",
    lightYellow: "#fff9e6",
    teal: "#003D4C",
    lightTeal: "#08586C",
    atlanticBlue: "#3F879E",
    greenDark: "#006150",
    lightOrange: "#FF9C0026",
    orange: "#FF9C00",
    lightRed: "#D2263026",
    blue: "#217BBE",
    lightBlue2: "#217BBE26",

    /* --borders --*/
    grayBorder: "2px solid #ccc",
    lightGrayBorder: "1px solid #E6E6E6 ",
    lightGrayBorderDashed: "1px dashed #d0d0ce",
    midGreyBorder: "1px solid #CFD0CF",
    greenBorder: "1px solid #008755",
    greenBorderThick: "2px solid #008755",
    redBorder: "1px solid #D22630",
    darkBlueBorder: "1px solid #003D4C",
    lightTielBorder: "1px solid #08586C",
    mintBorderBottom: "2px solid #9ED8B1",

    // breakpoints
    smallMobile: "360px",
    smallTablet: "620px",
    upToTablet: "767px",
    tablet: "768px",
    upToSmallDesktop: "939px",
    desktopSmall: "940px",
    desktop: "1200px",

    $font: `'Poppins', sans-serif`,

    // font bold
    fontBold: `"AnPostSansBold", sans-serif`,

    // font regular
    fontRegular: `"AnPostSansRegular", sans-serif`
};

export default ThemeProvider;
